import React from 'react';
import { useParams } from 'react-router';

import Form from '../../../../../components/form';
import DealType from '../../../../../enums/deal-type';
import TabsKeys from '../../../../../enums/tab-keys';
import { WAREHOUSE_MOVEMENT_INDEX } from '../../../../../router/routes';
import { route } from '../../../../../services/utils';
import { useDealState } from '../use-deal-state';
import { useDealUpdate } from '../use-deal-update';
import useEditFooter from '../use-edit-footer';
import { recycledSchema, useRecycledForm } from './use-recycled-form';
import { useWarehouseContext } from '../warehouse-context';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import DrawerForm from '../drawer-form';
import DrawerFormUsedProducts from '../drawer-form-used-products';
import WarehouseModal from '../warehouse-modal';
import { usedProductSchema } from '../use-used-product-form';
import { dealSchema } from '../use-deal-form';
import useDealErrorModal from '../use-deal-error-modal';

const MODE = 'edit';

export default function EditRecycled() {
  const { farmId, dealType } = useParams<{
    farmId: string;
    dealType: DealType;
  }>();
  const {
    isOpen,
    isOpenUsedProducts,
    isWarehouseModalOpen,
    PRODUCT_OBTAIN_REQUIRED,
  } = useWarehouseContext();

  const form = recycledSchema();

  const formMethods = useForm({
    resolver: yupResolver(form),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const drawerModalFormMethods = useForm({
    resolver: yupResolver(
      dealSchema(PRODUCT_OBTAIN_REQUIRED.includes(dealType))
    ),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const usedProductsDrawerModalFormMethods = useForm({
    resolver: yupResolver(usedProductSchema()),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const dealState = useDealState(DealType.recycled);
  const body = useRecycledForm(MODE);
  const footer = useEditFooter();
  const submit = useDealUpdate();
  const errorModal = useDealErrorModal(formMethods);

  return (
    <>
      {dealState && (
        <Form
          title={'pages.warehouse.deals.create-deal'}
          backTo={route(WAREHOUSE_MOVEMENT_INDEX, {
            farmId,
            tab: TabsKeys.deals,
          })}
          mode={MODE}
          body={body}
          footer={footer}
          values={dealState}
          schema={form}
          submit={submit}
          formMethods={formMethods}
        />
      )}

      {isOpen && (
        <DrawerForm
          formMethods={formMethods}
          drawerModalFormMethods={drawerModalFormMethods}
          keyValue="gained_products"
        />
      )}
      {isOpenUsedProducts && (
        <DrawerFormUsedProducts
          formMethods={formMethods}
          drawerModalFormMethods={usedProductsDrawerModalFormMethods}
        />
      )}
      {isWarehouseModalOpen && (
        <WarehouseModal formMethods={usedProductsDrawerModalFormMethods} />
      )}
      {errorModal}
    </>
  );
}
